module.exports = __webpack_public_path__ + "img/icon1.eb070513.svg";